import { Banner } from "@stenajs-webui/elements";

import type { DetailedBooking_autoCancellation } from "../../../../common/graphql/fragments/gql/DetailedBooking";
import { useLocalDateFormat } from "../../../../common/hooks/useLocalDateFormat";
import { Information } from "../../../../common/texts";
import { formatDateTime } from "../../../../common/utils/dates/dateUtils";

interface Props {
  info: DetailedBooking_autoCancellation | null;
}

export const AutoCancellationInfoBanner = ({ info }: Props) => {
  const dateFormat = useLocalDateFormat();

  if (!info) {
    return null;
  }

  const formattedDate = formatDateTime(info.departurePortDateTime, dateFormat);

  return (
    <Banner
      variant={"warning"}
      text={`${Information.AutoCancellationBeforeDatePrefix} ${formattedDate} ${Information.AutoCancellationBeforeDateSuffix}`}
    />
  );
};
